var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M0.240479 7.6263C0.240479 3.55582 3.54026 0.256042 7.61074 0.256042C11.6812 0.256042 14.981 3.55582 14.981 7.6263C14.981 11.6968 11.6812 14.9966 7.61074 14.9966C3.54026 14.9966 0.240479 11.6968 0.240479 7.6263ZM7.61074 1.73009C4.35435 1.73009 1.71453 4.36992 1.71453 7.6263C1.71453 10.8827 4.35435 13.5225 7.61074 13.5225C10.8671 13.5225 13.507 10.8827 13.507 7.6263C13.507 4.36992 10.8671 1.73009 7.61074 1.73009Z",
          fill: "#717986",
        },
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M7.61081 3.20416C8.01787 3.20416 8.34783 3.53414 8.34783 3.94119V6.83741C8.34783 7.044 8.34857 7.14895 8.35557 7.22383L8.35594 7.22759L8.35881 7.22995C8.41726 7.27726 8.50416 7.33608 8.67603 7.45069L10.2307 8.48709C10.5694 8.71292 10.6609 9.17054 10.4352 9.5092C10.2093 9.84786 9.75172 9.9394 9.41306 9.71365L7.85837 8.67717C7.85159 8.67268 7.84489 8.66818 7.8381 8.66368C7.69505 8.56831 7.54926 8.47117 7.43082 8.37521C7.29492 8.2651 7.15414 8.12536 7.04823 7.92739C6.94225 7.7295 6.90407 7.53478 6.88786 7.3607C6.87371 7.20887 6.87378 7.03368 6.87378 6.8618C6.87378 6.8537 6.87378 6.84551 6.87378 6.83741V3.94119C6.87378 3.53414 7.20375 3.20416 7.61081 3.20416Z",
          fill: "#717986",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }